module.exports = __webpack_public_path__ + "static/media/qr2.e09e566b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qr2.png
// module id = 22
// module chunks = 0